/// <reference path="PopupEmailPreview.js" />

class DeleteMessageDesign extends PopupEmailPreview {
	constructor(el, options) {
		super(el, options);
		this.subjectBox = document.getElementById(options.subjectBox);
		this.messageBox = document.getElementById(options.messageBox);
		this.itemId = options.itemId;
		this.emailAddress = options.emailAddress;
	}

	getParameters() {
		return {
			"PLH_subject": this.subjectBox.value,
			"PLH_message": this.messageBox.value,
		};
	}
}
